<template>
<div class="chapter">
<div class="inner_page">
<section class="drm" data-pdf-bookmark="Copyright Notice" data-type="preface" epub:type="preface"><div class="preface" id="d13e36"><h1 class="ChapTitleNonprintingctnp" data-displayheader="no" data-ncx="yes">Copyright Notice</h1><p class="CopyrightTextdoublespacecrtxd">The author and publisher have provided this e-book to you without Digital Rights Management software (DRM) applied so that you can enjoy reading it on your personal devices. This e-book is for your personal use only. You may not print or post this e-book, or make this e-book publicly available in any way. You may not copy, reproduce or upload this e-book, other than to read it on one of your personal devices.</p><p class="CopyrightTextdoublespacecrtxd"><strong>Copyright infringement is against the law. If you believe the copy of this e-book you are reading infringes on the author's copyright, please notify the publisher at: <a href="http://us.macmillanusa.com/piracy" target="_blank">http://us.macmillanusa.com/piracy</a>.</strong></p> </div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface02.vue?134faac8